import { AccountObjectDto } from "../account-object/account-object.dto";
import { DtoInclude, DtoRefList } from "../../../core/store/dto/dto";

export class DefaultTaskDto extends AccountObjectDto {
    @DtoInclude
    taskType: string;
    @DtoInclude
    title: string;
    @DtoRefList
    transitions: Array<string>;
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/default-task/default-task.dto.ts